export default "__VITE_ASSET__dDz1w_$j__"